import { Events } from 'models/event';
export const GOT_VENUE_EVENTS = 'got-venue-events';
const gotVenueEvents = ({ events }) => ({
  type: GOT_VENUE_EVENTS,
  payload: {
    events: Events(events),
  },
});
export default gotVenueEvents;
